import { RouteObject, Navigate } from 'react-router-dom';
import Home from '../pages/home';
import Album from '../pages/album';
import AlbumDetails from '../pages/albumDetails';
import KeepAlive from 'react-activation';
import Phone from '../pages/phone';

const routerList: RouteObject[] = [
    {
        id: "home",
        path: "/", //主页面
        element: <KeepAlive id="home">
            <Home />
        </KeepAlive>
    },
    {
        id: "album",
        path: "/album", //相册
        element: (
            <KeepAlive id="album">
                <Album />
            </KeepAlive>
        ),
    },
    {
        id: "phone",
        path: "/phone", //手机
        element: <Phone />
    },
    {
        id: "albumDetails",
        path: "/albumDetails", //详情
        element: <AlbumDetails />,
    }, 
    {
        path: "*",
        element: <Navigate to="/" />,
    }
];

export { routerList };
